import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import { ErrorBoundary } from '@nxte-nl/error-boundary';

import { BusinessPDPModalForm } from '../../components/BusinessPDPModalForm/BusinessPDPModalForm';
import {
  BusinessPDPOpenFormSection,
} from '../../components/BusinessPDPOpenFormSection/BusinessPDPOpenFormSection';
import { featureStateHooks } from '../../hooks/featureStateHooks/featureStateHooks';
import { languageHooks } from '../../hooks/languageHooks/languageHooks';
import { layoutHooks } from '../../hooks/layoutHooks/layoutHooks';
import { messageHooks } from '../../hooks/messageHooks/messageHooks';
import { modalHooks } from '../../hooks/modalHooks/modalHooks';
import { GlobalMessages } from '../../types/Messages';
import { ModalTypes } from '../../types/Modals';

export const hooks = {
  useGetStates() {
    const language = messageHooks.useSubjectState(GlobalMessages.Language);
    return { language };
  },
};

export const BusinessPDPOpenFormSectionContainer = () => {
  const {
    isOpenModal,
    onModalClose,
    onModalOpen,
  } = modalHooks.useModal(ModalTypes.BusinessPDPModalForm);
  const isMobileLayout = layoutHooks.useMobileLayout();
  const { isDesktop } = layoutHooks.useDesktop();

  const { language } = hooks.useGetStates();

  const currentLanguage = languageHooks.useGetLanguage(language,
    CONFIG.defaultLocale, CONFIG.applicationSiteGroup, CONFIG.locales);

  const langWithMessages = languageHooks.useGetLocaleAndMessage(currentLanguage);

  const { isPDPBusinessModalUsps } = featureStateHooks.useFeatureToggles();

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={CONFIG.reCaptchaKey}
      scriptProps={{ defer: true }}
    >
      <ErrorBoundary>
        <BusinessPDPOpenFormSection
          onModalOpen={onModalOpen}
          isDesktop={isDesktop}
          locale={langWithMessages?.locale}
        />
        <BusinessPDPModalForm
          isOpen={isOpenModal()}
          onClose={onModalClose}
          isMobileLayout={isMobileLayout}
          isDesktop={isDesktop}
          isPDPBusinessModalUsps={isPDPBusinessModalUsps}
        />
      </ErrorBoundary>
    </GoogleReCaptchaProvider>
  );
};

BusinessPDPOpenFormSectionContainer.displayName = 'BusinessPDPOpenFormSectionContainer';
